import React from 'react';
import { BorderLinearProgress } from './index.style';

const ProgressBar = ({ value }) => (
  <BorderLinearProgress variant="determinate" value={value} />
);

export default ProgressBar;
